import TomSelect from 'tom-select/popular';
import 'tom-select/dist/css/tom-select.default.css';

window.TomSelect = TomSelect;

window.initIndustryTomSelect = (industrySelect, onChange = null) => {
	const ts = new TomSelect(industrySelect, {
		create: false,
		sortField: [{ field: '$order' }, { field: '$score' }],
		maxItems: 1,
		allowEmptyOption: false,
		plugins: ['dropdown_input'],
		placeholder: industrySelect.dataset.placeholder,
	});

	if ( onChange ) {
		ts.on('change', onChange);
	}

	const selectedOption = industrySelect.querySelector('option[selected]');

	if ( selectedOption?.value ) {
		ts.setValue(selectedOption.value);
	}

	return ts;
};

document.dispatchEvent(new CustomEvent('industry-tom-select:ready'));

document.addEventListener('DOMContentLoaded', () => {
	const industrySelect = document.querySelector('#registration-form #industry');

	if ( ! industrySelect || industrySelect.tomselect ) {
		return;
	}

	window.initIndustryTomSelect(industrySelect);
});
